import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton,AppBar,Toolbar } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';

import Scrollbar from "perfect-scrollbar-react";
import classNames from "classnames";
import "perfect-scrollbar-react/dist/style.min.css";
import "react-table/react-table.css";
import Select from 'react-select';
import Loader from "other-components/loader/loader";
import Tooltip from 'material-ui/Tooltip';
import { withAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert'; // Import
import printjs from 'print-js';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';


const CustomTbodyComponent = props => (
    <div {...props} className={classNames("rt-tbody", props.className || [])}>
        <Scrollbar>{props.children}</Scrollbar>
    </div>
);


const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    smaller: {
        width: 30,
        height: 20,
    }
});


class JournalEntryReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fromDate :  moment(new Date()).format("YYYY-MM-DD"),
            toDate :  moment(new Date()).format("YYYY-MM-DD"),
            tableData : []
        };
    }

    handleTextBoxChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    handleViewClick(){
        if(!this.state.fromDate || !this.state.toDate
                || this.state.fromDate=='' || this.state.toDate==''){
            return this.props.alert.error('Select Date Range'); 
        }

        var reqBody = {
            fromDate : this.state.fromDate,
            toDate : this.state.toDate
        };
        const request = axios.post(window.accountServer+'/journalEntry/getJournalEntriesGrouped',reqBody);
        this.setState({loading:true});
        request.then((response)=>{
            if(response.data && !response.data.eroor && response.data.success){
                console.log('Journal Entry Data', response);
                var tableData = [];
                let index = 0;
                const journalEntries = response.data.journalEntries;
                for (var key in journalEntries) {
                    index++;
                    console.log('key ,' + key);
                    if (journalEntries.hasOwnProperty(key)) {
                        for(let i=0; journalEntries[key].length>i;i++){
                            let item = {};
                            if(i==0){
                                item.number = index;
                            }
                            else{
                                item.number = '';
                            }
                            item.date = journalEntries[key][i].DATE;
                            item.accountCode = journalEntries[key][i].LEDGER_REF_NO;
                            item.accountName = journalEntries[key][i].ACCOUNT_NAME;
                            item.debit = journalEntries[key][i].DR;
                            item.credit = journalEntries[key][i].CR;
                            tableData.push(item);
                        }
                    }
                 }
                 this.setState({
                    tableData : tableData,
                    loading : false
                 });
            }
            else{
                console.log('Journal Entry Fetch Error', response);
                this.props.alert.error('Data Fetch Error');
                this.setState({loading : false});
            }
        })
        .catch((error)=>{
            console.log('Journal Entry Fetch Error', error);
            this.setState({loading : false});
            this.props.alert.error('Data Fetch Error');
        });
    };

    handlePrintClick(){
        if(!this.state.fromDate || !this.state.toDate
            || this.state.fromDate=='' || this.state.toDate==''){
            return this.props.alert.error('Select Date Range'); 
        }

        var path = null;
        axios.post(window.reportServer+'/journalReport/getJournalReport', 
        {
            fromDate : this.state.fromDate,
            toDate : this.state.toDate
        }
        )
        .then(response => {
            path = response.data.path;
            path = window.reportServer+"/" + path;
            const url = path;
            window.open(url, '_blank');
        }
        );
    }

    render() {
        if (this.state.loading) {
            return (
                <Loader />
            );
        } else {
            return (
            <div>
                <div className="p-8">
                        <h2 className="subtitle-color invoice-margin">Journal Entry (Reporting)</h2>
                </div>

                <div className="p-8">
                    <TextField      
                        id="name"
                        className="inline-block w-1/5 -mt-8"
                        //className={classes.textField}
                        /* classes={{
                            input: classes.input
                        }} */
                        label="From Date"
                        placeholder=""
                        type="date"
                        value= {this.state.fromDate}
                        onChange={this.handleTextBoxChange('fromDate')}
                    />
                    <TextField
                        id="name"
                        className="inline-block w-1/5 -mt-8"
                        //className={classes.textField}
                        /* classes={{
                            input: classes.input
                        }} */
                        label="To Date"
                        placeholder=""
                        type="date"
                        value= {this.state.toDate}
                        onChange={this.handleTextBoxChange('toDate')}
                    />
                   
                </div>

                 <DialogActions className="justify-right pl-16">
                <Button
                        variant="raised"
                        color="secondary"
                        className="px-40 mx-16"
                        onClick = {
                            (ev)=>{
                                ev.stopPropagation();
                                this.handleViewClick();
                            }
                        }
                    >
                            View
                    </Button>
                    <Button
                        variant="raised"
                        color="secondary"
                        className="px-40 mx-16"
                        onClick = {
                            (ev)=>{
                                ev.stopPropagation();
                                this.handlePrintClick();
                            }
                        }
                    >
                            Print
                    </Button>
                 </DialogActions>   
                <div className="p-8">
                <ReactTable
                        data={this.state.tableData}
                        columns={[

                            {
                                Header: "Number",
                                accessor: "number"
                            },
                            {
                                Header: "Account Code",
                                accessor: "accountCode"
                            },
                            {
                                Header: "Account Name",
                                accessor: "accountName"
                            },
                            {
                                Header: "Debit",
                                accessor: "debit"
                            },
                            {
                                Header: "Credit",
                                accessor: "credit"
                            }
                        ]}
                        pageSize={10}
                        //defaultPageSize={10}
                        className="-striped -highlight"
                    />
                </div>
            </div>
            )
        }
        
    }

    componentWillMount() {
        
    }

}

    export default withStyles(styles, { withTheme: true })(withAlert(JournalEntryReport));










// WEBPACK FOOTER //
// ./src/main/content/accountingReports/journalEntryReport/JournalEntryReport.js